const WISHLIST_STORAGE_KEY = 'hz-custom:wishlist:v1';
const WISHLIST_EVENT = 'hz:wishlist-change';

class HzWishlistButton extends HTMLElement {
  #control;
  #label;

  connectedCallback() {
    this.#control = this.querySelector('[data-wishlist-control]');
    this.#label = this.querySelector('[data-wishlist-label]');
    if (!this.#control || !this.#label) return;

    this.#control.addEventListener('click', this.#handleClick);
    window.addEventListener('storage', this.#handleExternalChange);
    window.addEventListener(WISHLIST_EVENT, this.#handleExternalChange);
    this.#syncState();
  }

  disconnectedCallback() {
    this.#control?.removeEventListener('click', this.#handleClick);
    window.removeEventListener('storage', this.#handleExternalChange);
    window.removeEventListener(WISHLIST_EVENT, this.#handleExternalChange);
    this.#control = undefined;
    this.#label = undefined;
  }

  #readWishlist() {
    try {
      const value = JSON.parse(window.localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
      return Array.isArray(value)
        ? value.filter((item) => item && (typeof item.id === 'string' || typeof item.id === 'number'))
        : [];
    } catch {
      return [];
    }
  }

  #writeWishlist(items) {
    try {
      window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
    } catch {
      return false;
    }

    window.dispatchEvent(new CustomEvent(WISHLIST_EVENT, { detail: { productId: this.dataset.productId } }));
    return true;
  }

  #handleClick = () => {
    const items = this.#readWishlist();
    const index = items.findIndex((item) => String(item.id) === String(this.dataset.productId));

    if (index === -1) {
      items.push({
        id: this.dataset.productId,
        url: this.dataset.productUrl,
        title: this.dataset.productTitle,
        image: this.dataset.productImage,
      });
    } else {
      items.splice(index, 1);
    }

    if (this.#writeWishlist(items)) this.#syncState(items);
  };

  #handleExternalChange = (event) => {
    if (event.type === 'storage' && event.key !== null && event.key !== WISHLIST_STORAGE_KEY) return;
    this.#syncState();
  };

  #syncState(items = this.#readWishlist()) {
    if (!this.#control || !this.#label) return;

    const saved = items.some((item) => String(item.id) === String(this.dataset.productId));
    this.#control.setAttribute('aria-pressed', String(saved));
    this.#label.textContent = saved ? this.dataset.labelRemove : this.dataset.labelAdd;
  }
}

if (!customElements.get('hz-wishlist-button')) {
  customElements.define('hz-wishlist-button', HzWishlistButton);
}
